import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';

// Post request (axios) Getform.io
// import { postFormSubmit } from '../requests/form_request';
import { fetchOptions } from '../requests/options_request';

import Header from '../components/Header';
import ConsultForm from '../components/Forms/ConsultForm';
import Footer from '../components/Footer';

class Consulting extends Component {
    componentDidMount() {
        document.title = `Plan a consult - Friends for Brands`;
        window.scrollTo(0, 0);
    }

    componentWillMount() {
        this.getOptions(this.props, true);
    }

    getOptions(willMount = false) {
        if (willMount) {
            this.props.fetchOptions();
        }
    }

    render() {
        return (
            <div className="single page consulting">
                <Header />
                <main>
                    <div id="main-container">
                        <div className="content-container">
                            <ConsultForm
                                handleSubmit={this.handleSubmit}
                                data={
                                    this.props.options.fetched &&
                                    this.props.options.data.acf
                                }
                                loading={this.props.options.fetched}
                                className="fadeIn"
                            />
                        </div>
                    </div>
                </main>
                <Footer type="online-consult" />
            </div>
        );
    }
}

function mapStateToProps({ options }) {
    return { options };
}

export default withRouter(
    connect(mapStateToProps, { fetchOptions })(Consulting)
);



// WEBPACK FOOTER //
// ./src/containers/Consulting.js